module.exports = __webpack_public_path__ + "img/3.c0ecd544.jpg";